import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  list-style: none;
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  border-bottom: 1px solid #F1F1F1;
  padding: 19px 0 14px;
`;

const Classification = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
  color: #717171;
  text-transform: uppercase;
  border: 1px solid #F1F1F1;
  padding: 3px 9px;
  width: fit-content;
`;
const StandardText = styled.li`
  white-space: normal;
  height: auto;
  word-wrap: break-word;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #1F1F1F;
  padding-left: 2px;
`;

const StandardsListItem = ({classification, standardText, index}) => {
  return (
    <Wrapper>
      <Classification>{classification}</Classification>
      <StandardText>
        {index}. {standardText}
    </StandardText>
    </Wrapper>
  );
};

export default StandardsListItem;
